<template>
    <div :class="[cssClass, open ? 'open' : 'closed', toggleable ? 'toggleable' : 'disabled']">
        <div class="toggle" @click="toggleOptions(null, $event)">
            <slot name="toggle"></slot>
        </div>
        <div v-show="open" class="toggle-content">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ToggleSimple",
        emits: ['update:open'],
        props: {
            default: {
                type: Boolean,
                default: false
            },
            cssClass: {
                type: String,
                default: 'toggle-type-1'
            },
            toggleable: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                open: this.default || false
            }
        },
        methods: {
            toggleOptions(show = null, event = null) {
                if (event) { event.stopPropagation(); } // Prevent timing issues!
                if (!this.toggleable) return;
                this.open = show !== null ? show : !this.open;
            }
        },
        watch: {
            open(newValue) {
                this.$emit('update:open', newValue);
            }
        },
    }
</script>